import { css } from '@emotion/css'
import { getCustomTheme } from '../../chakraThemeExtension'

const theme = getCustomTheme()

const dateRangeModalStyles = css`
  text-align: left;

  .Modal__header {
    background-image: url('../../../../public/assets/img/filter-icon.svg');
    background-repeat: no-repeat;
    background-position: 30px 53px;

    h3 {
      font-size: 20px;
    }

    .subHeader {
      font-size: 12px;
      margin-top: 4px;
      color: ${theme.colors.grey.mid};
    }
  }
`

export default dateRangeModalStyles
